<div class="table-wrapper">
	<table
		#tableElementRef
		*ngIf="folderListDataSource"
		mat-table
		[dataSource]="folderListDataSource"
		fixedLayout="true"
		class="main-table"
	>
		<!-- Attention Needed Column -->
		<ng-container matColumnDef="attention_needed">
			<th mat-header-cell *matHeaderCellDef>
			</th>
			<td mat-cell *matCellDef="let folder">
				<dot-indicator [folder]="folder"></dot-indicator>
			</td>
		</ng-container>

		<!-- Folder Name Column -->
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>
				<span translate="common_name"></span>
			</th>
			<td mat-cell *matCellDef="let folder" [matTooltip]="folder.name">
				<span class="flex">
					<span class="folder {{FirstCommentTourClasses.folderTablePulse}}">
						<i class="ficon-folder-outline"></i>
					</span>
					<span class="folder-name">{{ folder.name }}</span>
				</span>
			</td>
		</ng-container>

		<!-- End Date Column -->
		<ng-container matColumnDef="end_date">
			<th mat-header-cell *matHeaderCellDef [hidden]="hasNoEndDate$ | async" data-cy="end-date-col">
				<span translate="course-table-end_date"></span>
			</th>
			<td mat-cell *matCellDef="let folder" [hidden]="hasNoEndDate$ | async">
				{{ folder.end_date | date:'mediumDate' }}
				<span *ngIf="!folder.end_date">&#8212;</span>
			</td>
		</ng-container>

		<!-- Last Updated Column -->
		<ng-container matColumnDef="updated_at">
			<th mat-header-cell *matHeaderCellDef>
				<span translate="course-table-last_modified"></span>
			</th>
			<td mat-cell *matCellDef="let folder">
				{{ folder.updated_at | date:'mediumDate' }}
			</td>
		</ng-container>

		<!-- Actions Column -->
		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let folder" (click)="$event.stopPropagation();" (keyup.enter)="$event.stopPropagation();">
				<span class="flex">
					<badge *ngIf="shouldShowFreeTrialBadge(folder)"
						class="free-trial-badge"
						[badgeColor]="BadgeColors.SUCCESS"
						[badgeLabel]="'folder-free-trial-badge-label' | translate">
					</badge>
					<comment-indicator
						*ngIf="folder.stats?.num_unviewed_comments"
						[unviewedComments]="folder.stats?.num_unviewed_comments">
					</comment-indicator>
					<button
						*ngIf="folder.hasInstructorRole(true) || userService.currentUser.is_root_user"
						mat-icon-button
						class="action-menu-btn"
						data-cy="course-menu"
						[attr.aria-label]="'session-list-item_view-options' | translate "
						(click)="openMenu($event, folder)">
						<i class="ficon-app-dots-vertical"></i>
					</button>
				</span>
			</td>
		</ng-container>
		<tr
			mat-header-row
			*matHeaderRowDef="displayColumns"
		></tr>
		<tr
			mat-row
			tabindex="0"
			class="{{FirstCommentTourClasses.folderTableComplete}}"
			[ngClass]="{ 'viewed': !unviewedState(folder)}"
			[attr.row-id]="folder.group_id"
			[attr.aria-label]="getAriaLabel(folder)"
			(contextmenu)="openMenu($event, folder)"
			(keyup.enter)="goToFolder.emit(folder)"
			(click)="goToFolder.emit(folder)"
			data-cy="folder-row-or-card"
			*matRowDef="let row; columns: displayColumns; let folder"
		></tr>
	</table>

	<menu>
		<folder-menu [folder]="selectedFolder"></folder-menu>
	</menu>
</div>
